webpackJsonp([1],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_css_swiper_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);











__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_8_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'error' });
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentFactory_js__ = __webpack_require__(246);
//




if (__webpack_require__.i({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__(247).default;
	var PDFJS = __webpack_require__(82);

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__(252);
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])({});
}

/* harmony default export */ __webpack_exports__["default"] = (component);

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_pdf__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: { pdf: __WEBPACK_IMPORTED_MODULE_1_vue_pdf___default.a },

  props: {},

  data: function data() {
    return {
      showPdf: false,
      pdfSrc: '../../static/assets/images/1.pdf',
      bannerList: [{
        img: '../../static/assets/images/021.jpg'
      }, {
        img: '../../static/assets/images/016.jpg'
      }, {
        img: '../../static/assets/images/017.jpg'
      }, {
        img: '../../static/assets/images/018.jpg'
      }, {
        img: '../../static/assets/images/019.jpg'
      }, {
        img: '../../static/assets/images/020.jpg'
      }, {
        img: '../../static/assets/images/015.jpg'
      }]
    };
  },

  methods: {
    submit: function submit(event) {
      this.showPdf = true;
    }
  },
  watch: {
    banner: {
      handler: function handler(newBanner, oldBanner) {
        this.$nextTick(function () {
          var mySwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container', {
            loop: true,
            pagination: {
              el: '.swiper-pagination',

              clickable: true
            },

            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },

            scrollbar: {
              el: '.swiper-scrollbar'
            }
          });
        });
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: null,
      email: null,
      phone: null,
      message: null
    };
  },

  methods: {
    submit: function submit(event) {
      var _this = this;

      console.log(this.name);
      console.log(this.email);
      console.log(this.phone);
      console.log(this.message);
      if (this.name == null || this.name === '') {
        this.msgError('姓名不能为空');
        return false;
      }
      if (this.name.length > 32) {
        this.msgError('姓名不能过长');
        return false;
      }
      if ((this.email == null || this.email === '') && (this.phone == null || this.phone === '')) {
        this.msgError('邮箱和手机号，至少填写一个');
        return false;
      }
      if (this.email != null && this.email !== '') {
        if (!/^(\w)+(.?\w*)*@[\da-z.-]+.([a-z]{2,6}|[\u2E80-\u9FFF]{2,3})$/.test(this.email)) {
          this.msgError('邮箱格式有误');
          return false;
        }
      }
      if (this.phone != null && this.phone !== '') {
        if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)) {
          this.msgError('手机号格式有误');
          return false;
        }
      }
      if (this.message == null || this.message === '') {
        this.msgError('详细信息不能为空');
        return false;
      }
      if (this.message.length > 500) {
        this.msgError('详细信息不能过长');
        return false;
      }
      this.$http({
        method: 'POST',

        url: 'https://localhost:8084/app/person/menhuData',
        data: { 'name': this.name, 'email': this.email, 'phone': this.phone, 'message': this.message },
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (res) {
        _this.msgSuccess('提交成功');
        _this.name = null;
        _this.email = null;
        _this.phone = null;
        _this.message = null;
      }).catch(function (err) {
        console.log(err);
        _this.msgError('提交失败,请稍后重试');
      });
    }
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isHovering1: false,
      isHovering2: false,
      isHovering3: false,
      isHovering4: false };
  }
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__(84);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bannerList: [{
        img: '../../static/assets/images/022.jpg'
      }, {
        img: '../../static/assets/images/023.jpg'
      }, {
        img: '../../static/assets/images/024.jpg'
      }, {
        img: '../../static/assets/images/025.jpg'
      }, {
        img: '../../static/assets/images/026.jpg'
      }, {
        img: '../../static/assets/images/027.jpg'
      }, {
        img: '../../static/assets/images/028.jpg'
      }, {
        img: '../../static/assets/images/029.jpg'
      }]
    };
  },

  watch: {
    banner: {
      handler: function handler(newBanner, oldBanner) {
        this.$nextTick(function () {
          var mySwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container', {
            loop: true,
            pagination: {
              el: '.swiper-pagination',

              clickable: true
            },

            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },

            scrollbar: {
              el: '.swiper-scrollbar'
            }
          });
        });
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/012.858ae5f.jpg";

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/013.1f31262.jpg";

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/014.bedf963.jpg";

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(135),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(136),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p3.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p4.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar"
  }, [_c('div', {
    staticClass: "single-widget search-widget"
  }, [_c('form', {
    staticClass: "example",
    staticStyle: {
      "margin": "auto",
      "max-width": "300px"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Posts",
      "name": "search2",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Search Posts'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget protfolio-widget"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/user2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h4', [_vm._v("Adele Gonzalez")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and\n              its detractors. Some people do not understand why you should have to spend money\n              on boot camp.\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dribbble"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-behance"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Categories")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Techlology")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Lifestyle")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Fashion")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Art")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Food")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Architecture")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Adventure")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget recent-posts-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Recent Posts")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, [_c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Archive")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Dec '17")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Nov '17")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Oct '17")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Sep '17")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Aug '17")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jul '17")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jun '17")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget tags-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tag Clouds")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lifestyle")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Adventure")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Techlology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Architecture")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])])])])])])])])])
}]}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "job-single-content section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "single-content1"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Assistant Executive - Production/ Quality Control")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "forth-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-content2 py-4"
  }, [_c('h4', [_vm._v("Senior Laravel Developer "), _c('br'), _vm._v("It Park International, USA")]), _vm._v(" "), _c('p', [_vm._v("Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content3 py-4"
  }, [_c('h4', [_vm._v("vacancy")]), _vm._v(" "), _c('span', {
    staticClass: "ml-4"
  }, [_vm._v("03")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content4 py-4"
  }, [_c('h4', [_vm._v("job responsibility")]), _vm._v(" "), _c('p', [_vm._v("Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered cheesed.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Dropped a clanger cuppa I chinwag  one plastered chee")]), _vm._v(" "), _c('li', [_vm._v("Cuppa I chinwag  one plastered cheesed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-content5 py-4"
  }, [_c('h4', [_vm._v("Educational Requirements")]), _vm._v(" "), _c('p', [_vm._v("Diploma in Engineering in Computer Science & Engineering, Bachelor in Engineering (BEngg) in Engineering (BEngg) in Computer Science & Enginetering")]), _vm._v(" "), _c('p', [_vm._v("Skills Required: JavaScript,PHP,WordPress,HTML5 & CSS3")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content6 py-4"
  }, [_c('h4', [_vm._v("employment status")]), _vm._v(" "), _c('span', [_vm._v("Part Time/Full Time")])]), _vm._v(" "), _c('div', {
    staticClass: "single-content7 py-4"
  }, [_c('h4', [_vm._v("other benifits")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-3"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered cheesed.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Mate dropped a clanger cuppa I chinwag  one plastered.")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Dropped a clanger cuppa I chinwag  one plastered chee")]), _vm._v(" "), _c('li', [_vm._v("Cuppa I chinwag  one plastered cheesed.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("jobs type")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Full Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Part Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Internship")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("job by location")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("New York")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("California")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Swizerland")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Canada")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Sweden")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("salary range")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$20,000-$30,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$25,000-$45,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$40,000-$70,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("filter by salary")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "range",
      "value": "",
      "name": "range"
    }
  })])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "newsletter-area job-single section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Get job information daily")]), _vm._v(" "), _c('p', [_vm._v("Subscribe to our newsletter and get a coupon code!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email here",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Your email here'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])])])])
}]}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Perfect pricing plan")]), _vm._v(" "), _c('p', [_vm._v("gormless cheeky bugger he nicked it golly gosh a arse show off show off")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("basic")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("standard")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("premium")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-building-o"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-box section-padding3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-box1 text-center mb-4 mb-md-0"
  }, [_c('h3', [_vm._v("submit resume today")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.")]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("submit your cv")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-box2 text-center"
  }, [_c('h3', [_vm._v("post a new job now!")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.")]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("post a job")])])])])])])])
}]}

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "id": "mySwiper"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.bannerList), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": banner.img,
        "mode": "aspectFill"
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "id": "mySwiper"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.bannerList), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": banner.img,
        "mode": "aspectFill"
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showPdf,
      "title": "",
      "width": "800px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showPdf = $event
      }
    }
  }, [_c('pdf', {
    attrs: {
      "src": _vm.pdfSrc
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("MENU")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(221),
      "mode": "aspectFill"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(222),
      "mode": "aspectFill"
    }
  })])])])])])])
}]}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": __webpack_require__(220),
      "mode": "aspectFill"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Book a table")]), _vm._v(" "), _c('p', [_vm._v("📞 0466900048")]), _vm._v(" "), _c('h2', [_vm._v("Trading Hours")]), _vm._v(" "), _c('p', [_vm._v("Thursday 3:00pm – 9:00pm")]), _vm._v(" "), _c('p', [_vm._v("Friday 12:00pm – 10:00pm")]), _vm._v(" "), _c('p', [_vm._v("Saturday 12:00pm – 10:00pm")]), _vm._v(" "), _c('p', [_vm._v("Sunday 12:00pm – 8:00pm")])])])])])])])
}]}

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding",
    staticStyle: {
      "padding-top": "80px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Contact us")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("Venue Address")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-group"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("5 Caldwell Street Mount Gambier 5290 ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Next to Forty Winks")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-table text-center"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("Contact Venue")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("📞 0466900048")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v(" ")])])])])])])])])
}]}

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-area"
  }, [_c('div', {
    staticClass: "search-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    staticClass: "d-md-flex justify-content-between",
    attrs: {
      "action": "#"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("All Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Part Time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Full Time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Remote")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Office Job")])]), _vm._v(" "), _c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Rajshahi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Barishal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Noakhali")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Keyword",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Search Keyword'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("find job")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center mt-5"
  }, [_c('span', [_vm._v("49 Results found for “Telecommunication”")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Assistant Executive - Production/ Quality Control")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn1",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Asst. Manager, Production (Woven Dyeing)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job2.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn2",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Deputy Manager/ Assistant Manager - Footwear")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job3.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn3",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("R&D Manager (Technical Lab Department)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job4.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Manager/ Asst. Manager (Quality Assurance)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job5.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn2",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "more-job-btn mt-5 text-center"
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("more job post")])])])])])
}]}

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header-top",
    staticStyle: {
      "background": "#fffaec",
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('el-col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": 12,
      "xs": 20
    }
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "margin-top": "0"
    },
    attrs: {
      "src": "static/assets/images/logo-light.png",
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "fontfamily",
    staticStyle: {
      "justify-content": "center",
      "align-self": "center",
      "font-weight": "600",
      "margin-left": "20px"
    }
  }, [_vm._v("\n            MOUNT GAMBIER BREWERY\n          ")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "justify-content": "center",
      "align-self": "center",
      "display": "flex"
    },
    attrs: {
      "span": 12,
      "xs": 4
    }
  }, [_c('div', {
    staticClass: "custom-navbar",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', {
    staticStyle: {
      "top": "110px"
    }
  }, [_c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("OPEN AND CLOSE")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/category"
    }
  }, [_vm._v("VENUE")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/blogDetails"
    }
  }, [_vm._v("MENU")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("CONTACT")])], 1)])])])], 1)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merquee"
  }, [_c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merquee"
  }, [_c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area",
    staticStyle: {
      "padding": "20px 0",
      "background": "#444447"
    }
  }, [_c('div', {
    staticClass: "footer-copyright",
    staticStyle: {
      "margin-top": "0px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px"
    }
  }, [_vm._v("\n          © 2024, mount gambier brewery pty ltd\n        ")])])])])
}]}

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Text Sample")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text"
  }, [_vm._v("\n        Every avid independent filmmaker has "), _c('b', [_vm._v("Bold")]), _vm._v(" about making that "), _c('i', [_vm._v("Italic")]), _vm._v(" interest documentary, or short film to show off their creative prowess. Many have great ideas and want to “wow” the"), _c('sup', [_vm._v("Superscript")]), _vm._v(" scene, or video renters with their big project.  But once you have the"), _c('sub', [_vm._v("Subscript")]), _vm._v(" “in the can” (no easy feat), how do you move from a "), _c('del', [_vm._v("Strike")]), _vm._v(" through of master DVDs with the "), _c('u', [_vm._v("“Underline”")]), _vm._v(" marked hand-written title inside a secondhand CD case, to a pile of cardboard boxes full of shiny new, retail-ready DVDs, with UPC barcodes and polywrap sitting on your doorstep?  You need to create eye-popping artwork and have your project replicated. Using a reputable full service DVD Replication company like PacificDisc, Inc. to partner with is certainly a helpful option to ensure a professional end result, but to help with your DVD replication project, here are 4 easy steps to follow for good DVD replication results:\n\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "button-area"
  }, [_c('div', {
    staticClass: "container border-top-generic"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Sample Buttons")]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area"
  }, [_c('a', {
    staticClass: "genric-btn default",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn primary e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn primary-border e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Left Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mt-sm-20 left-align-p"
  }, [_c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking systems that accept players from the United States that wish to play in online casinos.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border text-right"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Right Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("Over time, even the most sophisticated, memory packed computer can begin to run slow if we don’t do something to prevent it. The reason why has less to do with how computers are made and how they age and more to do with the way we use them. You see, all of the daily tasks that we do on our PC from running programs to downloading and deleting software can make our computer sluggish. To keep this from happening, you need to understand the reasons why your PC is getting slower and do something to keep your PC running at its best. You can do this through regular maintenance and PC performance optimization programs")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("Before we discuss all of the things that could be affecting your PC’s performance, let’s talk a little about what symptoms")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Definition")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 01")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 02")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 03")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Block Quotes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n              “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking”\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Table")]), _vm._v(" "), _c('div', {
    staticClass: "progress-table-wrap"
  }, [_c('div', {
    staticClass: "progress-table"
  }, [_c('div', {
    staticClass: "table-head"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v("Countries")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("Visits")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("Percentages")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f1.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f2.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-2",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f3.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-3",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "55",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f4.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-4",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("05")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f5.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-5",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("06")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f6.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-6",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "70",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("07")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f7.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-7",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("08")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f8.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-8",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "title_color"
  }, [_vm._v("Image Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "row gallery-item"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g1.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g1.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g2.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g2.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g3.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g4.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g4.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g5.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g5.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g6.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g6.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g7.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g7.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g8.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g8.jpg)"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-sm-6 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "typography"
  }, [_c('h1', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h2', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 02")]), _vm._v(" "), _c('h3', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 03")]), _vm._v(" "), _c('h4', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 04")]), _vm._v(" "), _c('h5', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h6', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Unordered List")]), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "unordered-list"
  }, [_c('li', [_vm._v("Fta Keys")]), _vm._v(" "), _c('li', [_vm._v("For Women Only Your Computer Usage")]), _vm._v(" "), _c('li', [_vm._v("Facts Why Inkjet Printing Is Very Appealing\n                  "), _c('ul', [_c('li', [_vm._v("Addiction When Gambling Becomes\n                      "), _c('ul', [_c('li', [_vm._v("Protective Preventative Maintenance")])])])])]), _vm._v(" "), _c('li', [_vm._v("Dealing With Technical Support 10 Useful Tips")]), _vm._v(" "), _c('li', [_vm._v("Make Myspace Your Best Designed Space")]), _vm._v(" "), _c('li', [_vm._v("Cleaning And Organizing Your Computer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Ordered List")]), _vm._v(" "), _c('div', {}, [_c('ol', {
    staticClass: "ordered-list"
  }, [_c('li', [_c('span', [_vm._v("Fta Keys")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("For Women Only Your Computer Usage")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Facts Why Inkjet Printing Is Very Appealing")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-alpha"
  }, [_c('li', [_c('span', [_vm._v("Addiction When Gambling Becomes")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-roman"
  }, [_c('li', [_c('span', [_vm._v("Protective Preventative Maintenance")])])])])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Dealing With Technical Support 10 Useful Tips")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Make Myspace Your Best Designed Space")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Cleaning And Organizing Your Computer")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Form Element")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "First Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'First Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "email",
      "name": "EMAIL",
      "placeholder": "Email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Email address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dilli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Newyork")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Islamabad")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select2"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bangladesh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("India")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("England")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Srilanka")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('textarea', {
    staticClass: "single-textarea",
    attrs: {
      "placeholder": "Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-primary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Primary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Primary color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-accent",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Accent color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Accent color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-secondary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Secondary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Secondary color'",
      "required": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 mt-sm-30 element-wrap"
  }, [_c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-switch"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-switch"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Selectboxes")]), _vm._v(" "), _c('div', {
    staticClass: "default-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Portuguise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bengali")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled Checkbox active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox-active"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Radios")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-radio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled radio")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled radio active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio-active"
    }
  })])])])])])])])])])
}]}

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "page-title text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_c('h2', [_vm._v("Freshest Haze '24")]), _vm._v(" "), _c('p', [_vm._v("Our Limited Release Fresh Hop Hazy IPA")])])])])])])])
}]}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_JobCategory__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_JobCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_JobCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_BlogHome__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_BlogHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_BlogHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_BlogDetails__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_BlogDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_BlogDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_JobSearch__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_JobSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_JobSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_JobSingle__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_JobSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_JobSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PricingPlan__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PricingPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_PricingPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Elements__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Elements__);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
  }, {
    path: '/category',
    name: 'category',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_JobCategory___default.a
  }, {
    path: '/blog',
    name: 'blog',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_BlogHome___default.a
  }, {
    path: '/blogDetails',
    name: 'blogDetails',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_BlogDetails___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ContactUs___default.a
  }, {
    path: '/jobSearch',
    name: 'jobSearch',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_JobSearch___default.a
  }, {
    path: '/jobSingle',
    name: 'jobSingle',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_JobSingle___default.a
  }, {
    path: '/pricingPlan',
    name: 'pricingPlan',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_PricingPlan___default.a
  }, {
    path: '/elements',
    name: 'elements',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Elements___default.a
  }]
}));

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {}
}));

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[134]);


// WEBPACK FOOTER //
// static/js/app.a10661522ad8c67fa4fa.js